var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { RouterConstants } from '../../../configuration/router.constants';
import * as Enumerable from 'linq';
import { BaseTemplate } from './base-template';
import { IFramePostMessages } from '../../../models/modules/lotteryplatform-client.models';
// import { setInterval } from 'timers';
import { DrawDateHelper } from '../../../models/modules/draw-date-helper';
import { BundleKeyHelper, TemplateType } from '../../../services/modules/brand-client.service';
import { InstantGameTypes } from '../../../models/modules/lotteryplatofrm.models';
import { computedFrom } from 'aurelia-binding';
var BaseLobby = /** @class */ (function (_super) {
    __extends(BaseLobby, _super);
    function BaseLobby(lotteryClientService, router, tokenClient, i18n, notificationClientService, dialogClient, configClientService, routingHelper, bindingSignaler) {
        var _this = _super.call(this, router, i18n, lotteryClientService, dialogClient, tokenClient) || this;
        _this.lotteryClientService = lotteryClientService;
        _this.notificationClientService = notificationClientService;
        _this.routingHelper = routingHelper;
        _this.bindingSignaler = bindingSignaler;
        _this.lotteriesCarousel = [];
        _this.quickPlayLotteries = [];
        _this.instantGames = [];
        _this.lotteryResults = [];
        _this._bundles = [];
        _this.scratchcards = [];
        _this.instantGameCards = [];
        _this.animating = false;
        _this.isShowMoreLotteries = false;
        _this.isShowMoreBundles = false;
        _this.defaultUserCurrencySymbol = tokenClient.getUserCurrency().symbol;
        _this.configClientService = configClientService;
        return _this;
    }
    Object.defineProperty(BaseLobby.prototype, "bundles", {
        get: function () {
            return this._bundles;
        },
        enumerable: false,
        configurable: true
    });
    BaseLobby.prototype.navigateToBundle = function (bundle) {
        this.router.navigateToRoute(RouterConstants.RouteNames.Bundle, {
            key: BundleKeyHelper.getKey(bundle.name),
            bundleId: bundle.bundleId
        });
    };
    BaseLobby.prototype.format = function (price) {
        if (price)
            return price.toFixed(2);
        return 0.00;
    };
    BaseLobby.prototype.onLotteriesLoaded = function () {
        var _this = this;
        this.attachResultsToLotteries();
        this._intervalDrawDateChecker = window.setInterval(function () {
            _this.lotteries.forEach(function (lottery) {
                var drawDate = new Date(lottery.closingDateTime);
                if (new Date() > drawDate && lottery.closingDateTime) {
                    var calculatedDate = DrawDateHelper.calculateNextDrawDate(lottery.isCustom, 2, false, lottery.sunday, lottery.monday, lottery.tuesday, lottery.wednesday, lottery.thursday, lottery.friday, lottery.saturday, drawDate, lottery.ticketSalesClosingTime);
                    var drawTimeDate = new Date(lottery.closingDateTime);
                    calculatedDate.setHours(drawTimeDate.getHours());
                    calculatedDate.setMinutes(drawTimeDate.getMinutes());
                    lottery.closingDateTime = calculatedDate;
                }
            });
        }, 5000);
        this.lotteryClientService.getCarouselLotteryKeys().then(function (list) {
            var carousel = Enumerable.from(list);
            _this.lotteriesCarousel = carousel.select(function (x) { return _this.getLotteryByKey(_this.lotteries, x); }).where(function (x) { return x != null; }).toArray();
        });
        this.lotteryClientService.getQuickPlayKeys().then(function (listQuickPlay) {
            var quickPlay = Enumerable.from(listQuickPlay);
            _this.quickPlayLotteries = quickPlay.select(function (x) { return _this.getLotteryByKey(_this.lotteries, x); }).where(function (x) { return x != null; }).toArray();
        });
    };
    BaseLobby.prototype.detached = function () {
        _super.prototype.detached.call(this);
        if (this._intervalDrawDateChecker) {
            this._intervalDrawDateChecker = null;
        }
    };
    BaseLobby.prototype.getAllResults = function () {
        return false;
    };
    BaseLobby.prototype.activate = function (params) {
        var _this = this;
        var promise = _super.prototype.activate.call(this, params);
        this.lotteryClientService.getLobbyLatestResults({
            getAll: this.getAllResults()
        }).then(function (x) {
            _this.lotteryResults = x;
            _this.attachResultsToLotteries();
        }, function (x) {
        });
        this.lotteryClientService.getLobbyBundles({}).then(function (x) {
            _this._bundles = x;
        }, function (x) {
        });
        this.clientLotteryClientService.getLobbyBrandInstantGames({}).then(function (x) {
            var filteredInstantGames = x.filter(function (z) { return z.instantGameTypeId == InstantGameTypes.InstantGame; });
            _this.instantGames = filteredInstantGames;
            var instantGameId = params.instantGameId;
            if (!instantGameId) {
                try {
                    var route = JSON.parse(localStorage.getItem("".concat(IFramePostMessages.reloadPage, "-previous-route")));
                    if (route && route.routeName == RouterConstants.RouteNames.Lobby && route.params && route.params.instantGameId) {
                        localStorage.removeItem(IFramePostMessages.reloadPage);
                        localStorage.removeItem("".concat(IFramePostMessages.reloadPage, "-previous-route"));
                        instantGameId = route.params.instantGameId;
                    }
                }
                catch (_a) {
                }
            }
            if (instantGameId) {
                var instantGame = Enumerable.from(x).firstOrDefault(function (x) { return x.instantGameId == instantGameId; });
                if (instantGame)
                    _this.showInstantGameDialog(instantGame);
            }
        }, function (x) {
        });
        this.clientLotteryClientService.getLobbyBrandScratchcards({}).then(function (x) {
            var instantGames = x;
            _this.lotteryClientService.getCarouselScratchcardKeys().then(function (list) {
                _this.scratchcards = [];
                list.forEach(function (t) {
                    var item = Enumerable.from(instantGames).firstOrDefault(function (z) { return t == _this.getInstantGameKey(z.instantGameName); });
                    if (item != null) {
                        _this.scratchcards.push(item);
                    }
                });
            });
            _this.lotteryClientService.getCarouselInstantGameCardsKeys().then(function (list) {
                _this.instantGameCards = [];
                list.forEach(function (t) {
                    var item = Enumerable.from(instantGames).firstOrDefault(function (z) { return t == _this.getInstantGameKey(z.instantGameName); });
                    if (item != null) {
                        _this.instantGameCards.push(item);
                    }
                });
            });
        }, function (x) {
        });
        return promise;
    };
    BaseLobby.prototype.showDefaultBundles = function (page, config, count) {
        return __awaiter(this, void 0, void 0, function () {
            var json, num;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.configClientService.getClientConfig(TemplateType.Config)];
                    case 1:
                        json = _a.sent();
                        num = json[TemplateType.Config][page][config];
                        if (this.isShowMoreBundles)
                            return [2 /*return*/, true];
                        if (count < num) {
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    BaseLobby.prototype.attachResultsToLotteries = function () {
        var e_1, _a;
        if (this.lotteryResults && this.lotteries)
            try {
                for (var _b = __values(this.lotteryResults), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var result = _c.value;
                    var lottery = Enumerable.from(this.lotteries).firstOrDefault(function (x) { return x.lotteryId == result.lotteryId; });
                    if (!lottery)
                        continue;
                    lottery.result = result;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
    };
    BaseLobby.prototype.getAnalyticsCategory = function (categoryLabel) {
        if (this.tokenClient && this.tokenClient.user) {
            var brandId = this.tokenClient.user.brandId;
            var playerId = this.tokenClient.user.playerId;
            var category = brandId + '_' + (!playerId || playerId === '' ? 'anonymous' : playerId) + '_' + categoryLabel;
            return category;
        }
        else {
            return "_anonymous_" + categoryLabel;
        }
    };
    BaseLobby.prototype.getTopBannerLottery = function (key) {
        key = this.i18n.tr(key);
        return this.getLotteryByKey(this.lotteries, key);
    };
    BaseLobby.prototype.getFeaturedLottery = function (key) {
        key = this.i18n.tr(key);
        return this.getLotteryByKey(this.lotteries, key);
    };
    BaseLobby.prototype.getLotteryById = function (lotteryId) {
        return Enumerable.from(this.lotteries).where(function (x) { return x.lotteryId == lotteryId; }).firstOrDefault();
    };
    BaseLobby.prototype.navigateToLotteryById = function (lotteryId) {
        var lottery = this.getLotteryById(lotteryId);
        var key = this.getLotteryKey(lottery.lotteryName);
        this.navigateToLottery(lottery);
    };
    BaseLobby.prototype.navigateToFilteredResults = function (lottery) {
        this.router.navigateToRoute(RouterConstants.RouteNames.Results, { lotteryId: lottery.lotteryId });
    };
    BaseLobby.prototype.navigateToResults = function () {
        this.router.navigateToRoute(RouterConstants.RouteNames.Results);
    };
    BaseLobby.prototype.navigateToLottery = function (lottery) {
        this.routingHelper.navigateToLottery(lottery);
    };
    BaseLobby.prototype.showInstantGameDialog = function (instantGame) {
        this.routingHelper.showInstantGameDialog(instantGame);
    };
    BaseLobby.prototype.navigateToLotteryAndSubscribe = function (lottery) {
        var key = this.getLotteryKey(lottery.lotteryName);
        this.router.navigateToRoute(RouterConstants.RouteNames.Lottery, {
            lotteryId: lottery.lotteryId,
            key: key,
            brandLotteryId: lottery.brandLotteryId,
            isSubscribe: true
        });
        window.dataLayer.push({
            "openedLotteryId": lottery.lotteryId,
            "openedLotteryName": lottery.lotteryName,
            "event": "navigate_lottery"
        });
    };
    BaseLobby.prototype.isClosing = function (lottery) {
        var dayInMinutes = 1440;
        var date1 = new Date().getTime();
        var date2 = new Date(lottery.drawDate).getTime();
        // Calculate the difference in milliseconds
        var difference = date2 - date1;
        var minutes = Math.floor(difference / 1000 / 60);
        if (minutes <= dayInMinutes) {
            return true;
        }
        return false;
    };
    BaseLobby.prototype.previous = function () {
        var _this = this;
        if (this.animating) {
            return;
        }
        var scrollElement = $(this.carouselBar);
        if (scrollElement) {
            var currentScrollLeft = scrollElement.scrollLeft();
            var liCollection = scrollElement.children();
            var length_1 = liCollection.length;
            var accumulator = 0;
            for (var idx = 0; idx < length_1; idx++) {
                accumulator += $(liCollection[idx]).outerWidth();
                if (accumulator - currentScrollLeft > 5) {
                    break;
                }
            }
            if (scrollElement.get(0)) {
                var newScrollLeft = currentScrollLeft - $(liCollection[idx]).outerWidth();
                this.animating = true;
                scrollElement.animate({
                    scrollLeft: newScrollLeft
                }, "linear", function () {
                    _this.animating = false;
                });
            }
        }
    };
    BaseLobby.prototype.next = function () {
        var _this = this;
        if (this.animating) {
            return;
        }
        var scrollElement = $(this.carouselBar);
        if (scrollElement) {
            var currentScrollLeft = scrollElement.scrollLeft();
            var liCollection = scrollElement.children();
            var length_2 = liCollection.length;
            var accumulator = 0;
            for (var idx = 0; idx < length_2; idx++) {
                accumulator += $(liCollection[idx]).outerWidth();
                if (accumulator - currentScrollLeft > 5) {
                    break;
                }
            }
            var width = scrollElement.width();
            var offset = 8;
            if (scrollElement.get(0)) {
                var scrollWidth = scrollElement.get(0).scrollWidth;
                var newScrollLeft = currentScrollLeft + $(liCollection[idx]).outerWidth();
                this.animating = true;
                scrollElement.animate({
                    scrollLeft: newScrollLeft
                }, "linear", function () {
                    _this.animating = false;
                });
            }
        }
    };
    Object.defineProperty(BaseLobby.prototype, "hideStoriesSideGradient", {
        get: function () {
            if (this.storiesScroller) {
                if (this.storiesScroller.offsetWidth + this.storiesScroller.scrollLeft > this.storiesScroller.scrollWidth - 50) {
                    return true;
                }
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    BaseLobby.prototype.showMoreLotteries = function () {
        this.isShowMoreLotteries = !this.isShowMoreLotteries;
    };
    BaseLobby.prototype.showMoreBundles = function () {
        this.isShowMoreBundles = !this.isShowMoreBundles;
        this.bindingSignaler.signal('update-bundles');
    };
    BaseLobby.prototype.getConfig = function (page, config) {
        return __awaiter(this, void 0, void 0, function () {
            var json, bob;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.configClientService.getClientConfig(TemplateType.Config)];
                    case 1:
                        json = _a.sent();
                        bob = json[TemplateType.Config][page][config];
                        return [2 /*return*/, bob];
                }
            });
        });
    };
    BaseLobby.prototype.showDefaultLotteries = function (page, config, count) {
        return __awaiter(this, void 0, void 0, function () {
            var json, num;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.configClientService.getClientConfig(TemplateType.Config)];
                    case 1:
                        json = _a.sent();
                        num = json[TemplateType.Config][page][config];
                        if (count < num) {
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    BaseLobby.prototype.isShowMoreLotteriesShowing = function (page, config, length) {
        return __awaiter(this, void 0, void 0, function () {
            var json, num;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.configClientService.getClientConfig(TemplateType.Config)];
                    case 1:
                        json = _a.sent();
                        num = json[TemplateType.Config][page][config];
                        if (length >= num) {
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    BaseLobby.prototype.isShowMoreBundlesShowing = function (page, config, length) {
        return __awaiter(this, void 0, void 0, function () {
            var json, num;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.configClientService.getClientConfig(TemplateType.Config)];
                    case 1:
                        json = _a.sent();
                        num = json[TemplateType.Config][page][config];
                        if (length > num) {
                            return [2 /*return*/, true];
                        }
                        else if (this.isShowMoreBundles)
                            return [2 /*return*/, true];
                        return [2 /*return*/, false];
                }
            });
        });
    };
    BaseLobby.prototype.showExtraLotteries = function (page, config, count) {
        return __awaiter(this, void 0, void 0, function () {
            var json, num;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.configClientService.getClientConfig(TemplateType.Config)];
                    case 1:
                        json = _a.sent();
                        num = json[TemplateType.Config][page][config];
                        if (count >= num) {
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    __decorate([
        computedFrom("_bundles", "isShowMoreBundles"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BaseLobby.prototype, "bundles", null);
    return BaseLobby;
}(BaseTemplate));
export { BaseLobby };
